import { styled } from '@mui/material';

export const Header = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: 10,
  alignItems: 'center',
  padding: '0px 16px 16px',
}));

export const ContentWrapper = styled('div')(() => ({
  position: 'relative',
  padding: '16px 0px',
  height: '100%',
}));

export const ControlWrapper = styled('div')(
  ({ isSelectValue }: { isSelectValue: boolean }) =>
    isSelectValue
      ? {
          paddingRight: 16,
          height: 420,
          overflowY: 'auto',
          marginBottom: 24,
        }
      : {
          paddingRight: 16,
        }
);

export const Content = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
}));

export const ButtonWrapper = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
}));
